import React from "react"
import { useState } from "react"
import { ChevronDown, Eye, EyeOff, HelpCircle, Globe } from "lucide-react"
import { Link, useLocation } from "react-router-dom";
import Logo from "../../assets/images/logo.png";
import { useTranslation } from "react-i18next";
import styles from "../../styles/__header.module.scss";


const Header = ({changeLanguage, hideLanguage = false}) => {
  const [selectedLanguage, setSelectedLanguage] = useState("English")
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false)
  const { t, i18n } = useTranslation();
  const location = useLocation();
  // Hide the language switcher on the login page or when explicitly requested.
  const isLoginPage = location.pathname === "/";


  const languages = [
    { code: "en", name: "English", flag: "🇺🇸" },
    { code: "ar", name: "العربية", flag: "🇸🇦" },
    // { code: "ku", name: "کوردی", flag: "🇮🇶" },
    // { code: "tr", name: "Türkçe", flag: "🇹🇷" },
    // { code: "fa", name: "فارسی", flag: "🇮🇷" },
  ]
const handleLanguageSelect = (language) => {
    setSelectedLanguage(language.name)
    changeLanguage(language.code)
    setShowLanguageDropdown(false)
  }


  return (
     <header className={styles["header"]}>
        <div className={styles["logo-section"]}>
          <div className={styles["logo"]}>
            <Link to="/"><img src={Logo} alt="Logo" /></Link>
          </div>
          {/* <div className={styles["brand-text"]}>
            <h1>TIRYAQ</h1>
            <p>ELECTRONIC HEALTH PLATFORM</p>
          </div> */}
        </div>
        <div className={styles["header-actions"]}>
          <button className={styles["help-btn"]}>
            <HelpCircle size={16} />
            {t("header.text")}
          </button>
          {!isLoginPage && !hideLanguage && (
            <div className={styles["language-dropdown-container"]}>
              <button className={styles["language-btn"]} onClick={() => setShowLanguageDropdown(!showLanguageDropdown)}>
                <Globe size={16} />
                {selectedLanguage}
                <ChevronDown size={16} className={showLanguageDropdown ? styles["rotated"] : ""} />
              </button>
              {showLanguageDropdown && (
                <div className={styles["language-dropdown"]}>
                  {languages.map((language) => (
                    <button
                      key={language.code}
                      className={`${styles["language-option"]} ${selectedLanguage === language.name ? styles["selected"] : ""}`}
                      onClick={() => handleLanguageSelect(language)}
                    >
                      <span className={styles["language-flag"]}>{language.flag}</span>
                      <span className={styles["language-name"]}>{language.name}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </header>
  )
}

export default Header
